import API from "./api";

const CertificateService = {
  // Get all certificates (admin)
  getAllCertificates: async (filters = {}) => {
    try {
      let url = "/certificates";
      const params = new URLSearchParams();
      if (filters.batch_id) params.append("batch_id", filters.batch_id);
      if (filters.student_id) params.append("student_id", filters.student_id);
      if (params.toString()) {
        url += "?" + params.toString();
      }
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get student certificates
  getStudentCertificates: async (studentId) => {
    try {
      const response = await API.get(`/certificates/student/${studentId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get certificate for specific batch
  getBatchCertificate: async (studentId, batchId) => {
    try {
      const response = await API.get(
        `/certificates/student/${studentId}/batch/${batchId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get students ready for certificate in a batch
  getReadyStudents: async (batchId) => {
    try {
      const response = await API.get(`/certificates/ready-students/${batchId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Upload certificate
  uploadCertificate: async (formData) => {
    try {
      const response = await API.post("/certificates/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  // Download certificate
  downloadCertificate: async (certificateId) => {
    try {
      const token = localStorage.getItem("token");
      // Use window.location.origin for dynamic domain, fallback to API.defaults.baseURL
      const baseURL =
        API.defaults.baseURL || `${window.location.origin}/backend`;
      const url = `${baseURL}/certificates/download/${certificateId}?token=${encodeURIComponent(token)}`;

      const link = document.createElement("a");
      link.href = url;
      link.download = `certificate_${certificateId}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download certificate error:", error);
    }
  },

  // View certificate in browser
  viewCertificate: async (certificateId) => {
    try {
      const token = localStorage.getItem("token");
      // Use window.location.origin for dynamic domain, fallback to API.defaults.baseURL
      const baseURL =
        API.defaults.baseURL || `${window.location.origin}/backend`;
      const url = `${baseURL}/certificates/view/${certificateId}`;

      window.open(`${url}?token=${token}`, "_blank");
    } catch (error) {
      console.error("View certificate error:", error);
    }
  },

  // Delete certificate
  deleteCertificate: async (id) => {
    try {
      const response = await API.delete(`/certificates/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  // Get ALL students in batch with certificate status
  getBatchCertificateStatus: async (batchId) => {
    try {
      const response = await API.get(
        `/certificates/batch/${batchId}/all-students`,
      );
      console.log("Raw API response:", response);
      // Return the full response - frontend will handle parsing
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Issue a new certificate (JSON - no file)
  // Issue a new certificate (JSON - no file)
  issueCertificate: async (certificateData) => {
    console.log("=== certificateService.issueCertificate ===");
    console.log("Sending data:", certificateData);
    try {
      const response = await API.post("/certificates/issue", certificateData);
      console.log("API Response:", response);
      console.log("Response data:", response.data);
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      console.error("Error response:", error.response);
      throw error;
    }
  },

  // Issue certificate with file upload (multipart form data)
  issueCertificateWithFile: async (formData) => {
    try {
      const response = await API.post("/certificates/issue", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default CertificateService;
